export default {
  DashBoard: {
    // vddung1
    RatingSubmit: 'Tỉ lệ nộp bài',
    RatingSuccess: 'Tỉ lệ làm đúng',
    Ranking: 'Hạng {sortOrder}',
    Notify: 'Thông báo',
    ExerciseResult: 'Kết quả bài tập gần đây',
    ViewMore: 'Xem thêm',
    ExerciseNonSubmit: 'Bài chưa nộp',
    ExerciseExpired: 'Bài sắp hết hạn',
    Progress: 'Tiến độ',
    ProgressInfo: '{ProgressInfo} câu',
    ExerciseName: 'Tên bài tập',
    TotalPassAnswer: 'Số câu đúng',
    TotalFailAnswer: 'Số câu sai',
    TotalUnFinishAnswer: 'Số câu chưa làm',
    RatingPass: 'Tỉ lệ đúng',
    DayOfComplete: 'Ngày làm bài',
    Deadline: 'Hạn nộp {deadLine}',
    NoExerciseDataTitle: 'Chưa có bài tập',
    ContentNoRanking:
      'Tăng tốc hoàn thành bài tập để thăng hạng thành tích nhé!',
    SortRankingEmpty: 'Chưa <br/> xếp hạng',
    NoNotifyDataTitle: 'Chưa có thông báo',
    Mission: 'Nhiệm vụ',
    CalendarDetail: 'Lịch học sắp tới',
    Courses: 'Khóa học',
    DeadlineContent: 'Hạn nộp:',
    CoursesEmpty: 'Chưa có khóa học',
    MissionEmpty: 'Chưa có nhiệm vụ',
    ListCourses: 'Cùng khám phá khóa học nhé!',
    StudentHardWorkingSmTablet: 'Tuyên dương học sinh chăm chỉ lớp {className}',
    StudentHardWorkingDesktop: 'Tuyên dương học sinh chăm chỉ lớp {className}',
    StudyEvaluateIndividual: 'Kết quả học tập của <br/> {firstName}',
    EvaluateIndividualHeader: 'Kết quả học tập của {firstName}',
    CommendationBoard:
      'Được tuyên dương <div class="text-dashboard-pink_light text-10xl">{count} lần</div> trong tháng',
    ExerciseOverview:
      'Bạn đã nộp <div class="text-dashboard-pink text-10xl">{totalExercise} bài tập</div> đúng hạn',
    SubmitExercise:
      'Bạn đã làm bài tập <div class="text-dashboard-purple text-10xl">{count} lần</div> trong tháng',
    RateSuccess:
      'Tổng số câu làm đúng của bạn là <div class="text-dashboard-blue text-10xl">{totalCorrect}/{totalQuestion}</div>',
    SubjectBest:
      '<div class="text-dashboard-purple_dark text-10xl">{subjectName}</div> là môn bạn học xuất sắc nhất',
    SubjectTryKeeping:
      'Bạn cần cố gắng hơn ở môn <div class="text-dashboard-orange text-10xl">{subjectName}</div>',
    MonthSummary: 'Tổng kết <br/> Tháng {currentMonth}',
    ExerciseOverviewDescription:
      'Tháng {numberMonth} bạn nộp <span class="font-bold text-dashboard-pink">đúng hạn {totalSubmit} bài tập</span> <br/> {extendStatistic}',
    SubjectTryKeepingDescription:
      'Với <span class="text-dashboard-orange font-bold">{count} lần</span> làm bài tập, <span class="text-dashboard-orange font-bold">đúng {totalCorrect}/{totalQuestion} câu</span>',
    SubjectBestDescription:
      'Với <span class="text-dashboard-purple_dark font-bold">{count} lần</span> làm bài tập, <span class="text-dashboard-purple_dark font-bold">đúng {totalCorrect}/{totalQuestion} câu</span>',
    CommendationBoardDescription:
      'Đạt kết quả xuất sắc ở <span class="text-dashboard-pink_light font-bold">{subjects}</span>',
    RateSuccessDescription:
      'Kết quả tháng {numberMonth} là <span class="text-dashboard-blue font-bold">{totalCorrectPrevious}/{totalQuestionPrevious}</span>',
    SubjectPratice:
      '{count} lần làm bài tập môn <span class="text-dashboard-purple font-bold">{subjectName}</span>',
    SubmitExerciseDescriptionSubject: 'Trong đó có {countSubjectPratice},...',
    SubmitExerciseDescription:
      '<br/> <span class="text-dashboard-purple font-bold">{totalCompareMonthPrevious} lần làm bài</span> so với tháng {numberMonth}',
    NotSubmitOverviewDescription:
      'Và có <span class="font-bold text-dashboard-pink">{totalExercise} bài chưa nộp</span>',
    NotSubmitOverviewDescriptionLower:
      'và có <span class="font-bold text-dashboard-pink">{totalExercise} bài chưa nộp</span>',
    SubmitFailOverviewDescription:
      'Nhưng có <span class="font-bold text-dashboard-pink">{totalExercise} bài nộp muộn</span>',
    ExercisStatisticOverview:
      'Bạn đã nộp <span class="font-bold text-primary">{totalExercise} bài tập</span> {extendStatistic}',
    ExercisStatisticOverviewNotExtend:
      'Bạn đã nộp <span class="h4 text-primary">{totalExercise} bài tập</span> đúng hạn',
    CommendationBoardOverview:
      'Lọt vào bảng vinh danh <span class="h2 text-primary">{count} lần</span> trong tháng',
    SubmitExerciseOverview:
      'Làm bài tập <div class="h2 text-primary">{count} lần</div>',
    RateSuccessOverview:
      'Tổng số câu làm đúng <div class="h2 text-primary">{totalCorrect}/{totalQuestion}</div>',
    SubjectBestOverview:
      'Môn học tốt nhất là <div class="h2 text-primary">{subjectName}</div>',
    SubjectTryKeepingOverview:
      'Môn cần cố gắng hơn là <div class="h2 text-primary">{subjectName}</div>',
    NotSubmitOverview:
      'và có <span class="font-bold text-primary">{totalExercise} bài chưa nộp</span>',
    SubmitFailOverview:
      'nhưng có <span class="font-bold text-primary">{totalExercise} bài nộp muộn</span>',
    RankLabel: 'Hạng',
    FullNameLabel: 'Họ tên',
    BirthdayLabel: 'Ngày sinh',
    TotalPracticeLabel: 'Số lần làm bài tập',
    RateSuccessLabel: 'Tỉ lệ làm đúng',
    AnswerSuccessLabel: 'Số câu đúng',
    StudyHardworkingEmpty: 'Chưa có xếp hạng',
    IndividualEvaluateEmpty: 'Không có kết quả học tập',
    Reduction: 'Giảm',
    Increase: 'Tăng',
    TimeReviewRanking: 'Từ {fromDate} đến {toDate}',
    NotifyStarRanking:
      'Bạn vừa nhận được <b>{countStar} sao học tập</b> vì đã đạt <b>Hạng {rankWeek}</b> học sinh chăm chỉ {subjectName} {timeToReview}',
    Subject: 'môn',
    Weekly: 'tuần {numberWeek}',
    TimeReviewRankingLowercase: 'từ {fromDate} đến {toDate}',
    WeeklyCap: 'Tuần {numberWeek}'
  }
}
